import { useRegisterActions } from 'kbar';
import FeatureName from '@constants/featureName';
import { isFeatureOn } from '@utils/featureGates/featureGatingHelper';
import useFeatureFlagControls from 'src/hooks/useFeatureFlagControls';
import { KBAR_SECTION_NAME } from '@constants/strings';

export default function useFeatureGatingActions() {
  const { setFeatureStatus, setAllFeaturesOn, setAllFeaturesOff, setAllFeaturesDefault } = useFeatureFlagControls();
  const featureGatingActions = [];
  const setAllFeaturesOnAction = {
    id: 'featureGatingSetAllFeaturesOn',
    name: 'Set all features on',
    section: KBAR_SECTION_NAME,
    perform: () => {
      setAllFeaturesOn();
      // eslint-disable-next-line
      alert('All feature flag are set to true. Please refresh the page to take effect.');
    },
  };
  featureGatingActions.push(setAllFeaturesOnAction);

  const setAllFeaturesOffAction = {
    id: 'featureGatingSetAllFeaturesOff',
    name: 'Set all features off',
    section: KBAR_SECTION_NAME,
    perform: () => {
      setAllFeaturesOff();
      // eslint-disable-next-line
      alert('All feature flag are set to false. Please refresh the page to take effect.');
    },
  };
  featureGatingActions.push(setAllFeaturesOffAction);
  const setSpecificFeatureStatusParentAction = {
    id: 'setSpecificFeatureStatus',
    name: 'Enable/Disable/Show current status for a specific feature flag...',
    section: KBAR_SECTION_NAME,
  };
  featureGatingActions.push(setSpecificFeatureStatusParentAction);

  const setAllFeaturesDefaultAction = {
    id: 'featureGatingSetAllFeaturesDefault',
    name: 'Set all features to default status (reset)',
    section: KBAR_SECTION_NAME,
    perform: () => {
      setAllFeaturesDefault();
      // eslint-disable-next-line
      alert('All feature flags have been reset. Please refresh the page to take effect.');
    },
  };
  featureGatingActions.push(setAllFeaturesDefaultAction);

  Object.keys(FeatureName).forEach((featureNameEnumKey) => {
    // eslint-disable-next-line
    // @ts-ignore
    const featureName = FeatureName[featureNameEnumKey] as FeatureName;
    const currentFeatureStatus = isFeatureOn(featureName);
    featureGatingActions.push({
      id: featureName.toString(),
      name: `${featureName.toString()}: ${currentFeatureStatus.toString()}. Click to change.`,
      perform: () => {
        setFeatureStatus(featureName, !currentFeatureStatus);
        // eslint-disable-next-line
        alert(`${featureName} is now set to ${!currentFeatureStatus}. Please refresh the page to take effect.`);
      },
      parent: setSpecificFeatureStatusParentAction.id,
    });
  });

  useRegisterActions(featureGatingActions);
}
